module.exports = __webpack_public_path__ + "img/ddos-d.58afbfe.svg";